import { createStyles, makeStyles } from "@material-ui/core/styles";
import { HEIGHT_HEADER } from "config/constant";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.common.white,
				height: `calc(100vh - ${HEIGHT_HEADER}px)`
			},
			headerRegister: {
				display: "flex",
				alignItems: "center",
				padding: "30px 0px 20px",
				borderBottom: `1px solid ${theme.palette.grey[800]}`,
				"& > img": {
					marginRight: 20
				}
			},
			titleHeader: {
				fontSize: 20,
				fontWeight: 500,
				color: theme.palette.primary.contrastText
			},
			subTitleHeader: {
				fontSize: 14,
				marginTop: 5,
				color: theme.palette.grey[700]
			},
			rootForm: {
				padding: 20
			},
			btnBack: {
				width: "fit-content",
				cursor: "pointer",
				"&:hover": {
					opacity: 0.7
				}
			},
			title: {
				fontSize: 16,
				fontWeight: 500,
				display: "flex",
				alignItems: "center",
				color: theme.palette.error.main,
				"& > img": {
					marginRight: 5
				},
				"& >span": {
					color: theme.palette.error.main,
					marginLeft: 3
				}
			},
			borderTitle: {
				borderBottom: `1px dashed ${theme.palette.grey[800]}`,
				paddingBottom: 10,
				marginBottom: 10
			},
			customInput: {
				color: theme.palette.error.main,
				marginTop: 5,
				marginBottom: 15,
				"& > .MuiInput-root": {
					height: "inherit",
					border: "1px solid #c4c4c3",
					borderRadius: 6
				},
				height: "100%",
				width: "100%",
				"& > div > input": {
					color: theme.palette.primary.contrastText,
					height: 37,
					backgroundColor: theme.palette.grey["A100"],
					fontSize: 18,
					lineHeight: "21px",
					padding: "3px 10px",
					"@media only screen and (max-width: 768px)": {
						fontSize: 16,
						lineHeight: "19px"
					}
				},
				"& > div > textarea": {
					color: theme.palette.primary.contrastText,
					margin: 10,
					backgroundColor: theme.palette.grey["A100"]
				},
				"& > .MuiInput-underline:before": {
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`,
					content: "none"
				},
				"& > .MuiInput-underline:after": {
					content: "none",
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`
				},
				"& > div > .MuiSelect-select.MuiSelect-select": {
					color: theme.palette.error.main,
					textAlign: "initial",
					marginLeft: 15
				}
			},
			inputError: {
				border: `1px solid ${theme.palette.error.main} !important`,
				borderRadius: "6px !important"
			},
			bodyBtnSubmit: {
				padding: "10px 0px",
				textAlign: "center",
				width: "100%"
			},
			btnSubmit: {
				background: theme.palette.primary.main,
				color: theme.palette.text.contrastText,
				fontSize: 14,
				textTransform: "capitalize",
				width: 167,
				height: 36,
				borderRadius: 6,
				"&:active": {
					background: theme.palette.primary.main,
					opacity: 0.7
				},
				"&:hover": {
					background: theme.palette.primary.main
				},
				"&.MuiButton-root.Mui-disabled": {
					background: theme.palette.secondary.dark,
					color: theme.palette.common.white
				}
			},
			textError: {
				fontSize: 12,
				marginBottom: 5,
				color: theme.palette.error.main
			},
			rootFooter: {
				position: "absolute",
				bottom: 0,
				width: "100%",
				background: theme.palette.common.white
			},
			body: {
				height: `calc(100vh - ${HEIGHT_HEADER + 112}px)`,
				overflow: "scroll"
			},
			btnCancel: {
				width: 167,
				height: 36,
				textTransform: "capitalize",
				color: theme.palette.primary.contrastText,
				borderRadius: 6
			},
			btnRejectAcc: {
				color: `${theme.palette.secondary.main}`,
				textAlign: "center",
				fontWeight: 500,
				marginTop: 20,
				cursor: "pointer",
				"&:active": {
					color: theme.palette.secondary.main,
					opacity: 0.7
				}
			},
			rootHeader: {
				display: "flex",
				alignItems: "center",
				color: theme.palette.error.main,
				fontSize: 16,
				fontWeight: 500,
				"& >img": {
					marginRight: 5
				}
			},
			checkedRadio: {
				color: `${theme.palette.secondary.main} !important`
			},
			rootRadio: {
				fontSize: 16,
				fontWeight: 400
			}
		}),
	{
		name: "DeleteAccountPage",
		index: 1
	}
);

export default useStyles;
